import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ShellComponent } from './shared/shell/shell.component';
import { AdeHomeComponent } from './pages/home/home.component';
import { AdeDealerPageComponent } from './pages/dealer-page/dealer-page.component';
import { AdeVeiculoComponent } from './pages/veiculo/veiculo.component';
import { AdeArtigoComponent } from './pages/artigo/artigo.component';
import { AdePesquisaComponent } from './pages/pesquisa/pesquisa.component';

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      { path: '', component: AdeHomeComponent },
      { path: 'artigo/:slug', component: AdeArtigoComponent },
      { path: 'pesquisa', component: AdePesquisaComponent },
      // detalhe de produto: /:section/:slug (qualquer secção de listagem)
      { path: ':section/:slug', component: AdeVeiculoComponent },
      // páginas dinâmicas (listing ou content) definidas no Strapi
      { path: ':slug', component: AdeDealerPageComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AutodepocaRoutingModule {}
